import React from 'react';
import { Input } from 'antd';

const { TextArea: AntdTextarea } = Input;
const TextArea = props => <AntdTextarea {...props} className="theme-input" />;

export default TextArea;
